(function () {
	'use strict';

	angular
		.module('smb-app')
		.factory('smbDeletedItemsService', [
			'$http',
			'$q',
			'pxUriPathService',
			DeletedItemsService
		]);

	function DeletedItemsService($http, $q, pxUriPathService) {

		return {
			/**
			 * @ngdoc method
			 * @name smbDocumentNotesService#getAdminTrash
			 * @methodOf smb-app.smbDeletedItemsService
			 * @kind function
			 * 
			 * @description
			 * Gets the collection of all deleted items from the deployment.
			 * 
			 * @returns {Deferred<DocumentNote>} A promise that resolves to a collection of deleted document objects.
			 */
			getAdminTrash: getAdminTrash,
			/**
			 * @ngdoc method
			 * @name smbDocumentNotesService#purge
			 * @methodOf smb-app.smbDeletedItemsService
			 * @kind function
			 * 
			 * @description
			 * Permanently deleted the provided item from the system.
			 * 
			 * @param {object} item The trash item to permanently delete.
			 *
			 * @returns {Deferred} A promise that resolves if the purge succeeded.
			 */
			purge: purge,
			/**
			 * @ngdoc method
			 * @name smbDocumentNotesService#restore
			 * @methodOf smb-app.smbDeletedItemsService
			 * @kind function
			 * 
			 * @description
			 * Restores the provided item and removes it from trash.
			 * 
			 * @param {object} item The trash item to restore.
			 *
			 * @returns {Deferred} A promise that resolves to the restored item.
			 */
			restore: restore
		};

		function getAdminTrash() {
			var uri = pxUriPathService.resolvePath('/admin/trash');

			return $http.get(uri)
				.then(function(resp) {
					return resp.data;
				});
		}

		function restore(item){	
			var p = $q.reject(new Error('Invalid item to restore.'));
			if(item && item.Links) {		
				p = $http.patch(item.Links.RestoreUri)
					.then(function(resp){
						return resp.data;
					});				
			}

			return p;
		}

		function purge(item) {
			var p = $q.reject(new Error('Must provide a valid item to purge.'));
			if(item && item.Links) {
				var uri = item.Links.Self + '?purge=true';
				p = $http.delete(uri);
			}

			return p;
		}
	}
})();


//////////////////
// WEBPACK FOOTER
// ./app/services/deletedItemsService.js
// module id = 148
// module chunks = 1